import {chartsApiUrl, isServer} from "../../../common/app/read_charts_web_environment_variables";

/** Ścieżka z API (`/media/...`) → pełny URL na SSR, względna w przeglądarce (proxy / ten sam host). */
export const resolveNewshubMediaUrl = (path: string): string => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }

    const normalized = path.startsWith("/") ? path : `/${path}`;

    return isServer ? `${chartsApiUrl}${normalized}` : normalized;
};
